import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "searchFilter",
})
export class SearchFilterPipe implements PipeTransform {
  transform(items: any, filter: any, callback?: any, ins?: any): any {
    if (!items || !callback) {
      return items;
    }
    return callback(ins, items, filter);
  }
}
